import { object } from 'yup';
import { TFunction } from 'i18next';

import {
  optionalPersonNameField,
  requiredAddressLineField,
  requiredEmailField,
  requiredIcoField,
  requiredNbsRegistrationNumberField,
  requiredPartnerNumberField,
  requiredPersonNameField,
  requiredPhoneObjectField,
  requiredString,
} from 'common/validation';

export function makeCompanyInfoSchema(t: TFunction, language = 'cz') {
  return object().shape({
    gender: requiredString(t),
    firstName: requiredPersonNameField(t),
    lastName: requiredPersonNameField(t),
    partnerNumber: requiredPartnerNumberField(t),
    ico: language === 'sk' ? requiredNbsRegistrationNumberField(t) : requiredIcoField(t),
    address: requiredAddressLineField(t),
    email: requiredEmailField(t),
    phone: requiredPhoneObjectField(t),
    title: optionalPersonNameField(t),
  });
}
